import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "bell",
  "use": "bell-usage",
  "viewBox": "0 0 15 15",
  "content": "<symbol viewBox=\"0 0 15 15\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"bell\">\r\n<path d=\"M1 10.5H14M2.5 10.5V5.5C2.5 2.73858 4.73858 0.5 7.5 0.5C10.2614 0.5 12.5 2.73858 12.5 5.5V10.5M5.5 12V12.5C5.5 13.6046 6.39543 14.5 7.5 14.5C8.60457 14.5 9.5 13.6046 9.5 12.5V12\" stroke=\"#409EFF\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol